import {
    ConfirmationStage,
    SelectProductAndQuantityStage,
    SelectSourcePartitionStage,
    SelectTargetPartitionStage
} from "./stages";
import { FC, useCallback, useState } from "react";
import Wizard, { WizardStep } from "features/common/Wizard";

import { IntroStage } from "features/common/stages";
import { createMovement } from "domains/allocations/services/allocation-service";
import localisations from "../../localisation";

type MovementAllocationFeatureProps = {
    fieldCompanyId: number;
};

const MovementAllocationFeature: FC<MovementAllocationFeatureProps> = ({fieldCompanyId}) => {
    const { intro, selectSourcePartition, selectTargetPartition, selectProductAndQuantity, confirmation } = localisations.movementAllocation.stepper;
    const [fields, setFields] = useState({} as any);
    const [transferProductStatus, setTransferProductStatus] = useState(false);
    const [productQuantityStatus, setProductQuantityStatus] = useState(false);

    const handleFieldChange = useCallback((newFields: any) => setFields((x:any) => ({ ...x, ...newFields })), [setFields]);
    const handleTransferProductStatus  = useCallback((status: boolean) => setTransferProductStatus(status), [setTransferProductStatus]);
    const handleProductQuantityStatus = useCallback((status: boolean) => setProductQuantityStatus(status), [setProductQuantityStatus]);

    let childProps = {
        fieldCompanyId,
        fields,
        handleFieldChange,
        handleTransferProductStatus,
        handleProductQuantityStatus
    }

    let steps = [
        {
            label: intro,
            component: <IntroStage localisations={localisations.movementAllocation.stages.intro}/>
        },
        {
            label: selectSourcePartition,
            component: <SelectSourcePartitionStage {...childProps} />,
            disableNextButton:() => fields.sourcePartitionDetails?.id == null
        },
        {
            label: selectProductAndQuantity,
            component: <SelectProductAndQuantityStage {...childProps} />,
            disableNextButton:() => !(transferProductStatus && productQuantityStatus)
        },
        {
            label: selectTargetPartition,
            component: <SelectTargetPartitionStage {...childProps} />,
            disableNextButton:() => fields.targetPartitionDetails?.id == null
        },
        {
            label: confirmation,
            component: <ConfirmationStage {...childProps}/>,
            onNext: async ():Promise<boolean> => {
                await createMovement({
                    fieldCompanyId: fieldCompanyId,
                    sourcePartitionId: fields.sourcePartitionDetails?.id,
                    targetPartitionId: fields.targetPartitionDetails?.id,
                    productId: fields.productDetails?.id,
                    quantityChange: fields.quantityChange
                });
                return true;
            }
        }
    ] as WizardStep[];

    return (
        <Wizard
            fieldCompanyId={fieldCompanyId}
            steps={steps}
            resultStageLocalisations={localisations.movementAllocation.stages.result}
            serverErrorLocalisations={localisations.movementAllocation.serverErrors}
        />
    );
}

export default MovementAllocationFeature;